// Компонент создания агента - полностью готов
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MustMatch } from 'src/app/helpers/must-match';
import { IRegistration } from 'src/app/interfaces/agent/iregistration';
import { AgentService } from 'src/app/services/agent.service';
import { CommissionService } from 'src/app/services/commission.service';
import { DictionaryService } from 'src/app/services/dictionary.service';
import { appConfig } from 'src/assets/config/application-config';

@Component({
  selector: 'app-add-agent',
  templateUrl: './add-agent.component.html',
  styleUrls: ['./add-agent.component.css']
})
export class AddAgentComponent implements OnInit {

  iinLengthCheck = appConfig["add_agent_iin_length"];
  phonePrefix = appConfig["add_agent_phone_prefix"];

  addAgentForm = this.fb.group({
    email: [null, [Validators.required, Validators.email]],
    lname: [null, Validators.required],
    name: [null, Validators.required],
    pname: [null],
    phone: [null, [Validators.required, Validators.pattern(appConfig["add_agent_phone_pattern"])]],
    address: [null, Validators.required],
    iin: [null, [Validators.required, Validators.pattern(appConfig["add_agent_iin_pattern"])]],
    company: [null, Validators.required],
    region: [null, Validators.required],
    cityId: [null, Validators.required],
    template: [null, Validators.required],
  });
  hide = true;
  hasUnitNumber = false;

  regions = [];
  cities = [];
  templates = [];
  isCompleted: boolean = false;
  constructor(private fb: FormBuilder,
    private router: Router,
    private agentSrv: AgentService,
    private dictionarySrv: DictionaryService,
    private commissionSrv: CommissionService,
    public snackBar: MatSnackBar,
    private translate: TranslateService) { }

  ngOnInit(): void {
    this.getRegions();
    this.getCities();
    this.getTemplates();
  }

  getRegions() {
    this.dictionarySrv.getRegions().subscribe(
      (data: any) => { this.regions = data; },
      error => console.log(error)
    )
  }

  getCities() {
    this.dictionarySrv.getCities().subscribe(
      (data: any) => { this.cities = data; },
      error => console.log(error)
    )
  }

  getTemplates() {
    this.commissionSrv.get().subscribe(
      (data: any) => { this.templates = data; },
      error => console.log(error)
    ).add(() => { this.isCompleted = true });
  }

  // convenience getter for easy access to form fields
  get f() { return this.addAgentForm.controls; }

  public hasError = (controlName: string, errorName: string) => {
    return this.addAgentForm.controls[controlName].hasError(errorName);
  }

  public create = (addAgentForm) => {
    if (this.addAgentForm.valid) {
      this.executeCreation(addAgentForm);
    }
  }

  private executeCreation = (data) => {
    this.isCompleted = false;
    let json: IRegistration = {
      lname: data.lname,
      name: data.name,
      pname: data.pname,
      company: data.company,
      companyBin: data.iin.toString(),
      address: data.address,
      email: data.email,
      iin: data.iin.toString(),
      phone: Number(data.phone),
      templateId: Number(data.template),
      regionId: data.region,
      cityId: data.cityId
    }
    
    this.agentSrv.createSubAgent(json)
      .subscribe(
        data => {
          // Агент успешно создан!
          this.router.navigate(['/agents']);
        },
        error => {
          if (error.status === 409) {
            let message = this.translate.instant('user-is-already-registered');
            this.openSnackBar(message, 'x');
          }
          else
            if (error.status === 400) {
              let message = this.translate.instant('user-is-already-registered');
              this.openSnackBar(message, 'x');
            }
            else
              if (error.status === 500) {
                let message = this.translate.instant('service-is-temporarily-unavailable');
                this.openSnackBar(message, 'x');
              }
              else {
                let message = this.translate.instant('an-error-occurred-while-processing');
                this.openSnackBar(message, 'x');
              }
        }
      ).add(() => { this.isCompleted = true });
  }


  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 5000,
    });
  }
}
